import React, {useEffect} from 'react';
import {withProviderOnboarding} from 'components/HOCs/withProviderOnboarding';
import {
  selectFetchReceiptsIsLoading,
  selectReceipts,
} from 'features/Payment/paymentSelectors';
import {fetchReceipts} from 'features/Payment/Receipts/receiptActions';
import {ReceiptsList} from 'features/Payment/Receipts/ReceiptsList';
import ReceiptsListSkeletonLoader from 'features/Payment/Receipts/ReceiptsListSkeletonLoader';
import {selectUserProfile} from 'features/User/userSelectors';
import {MemberProfile} from 'interfaces';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

function DPReceipts() {
  const user = useSelector(selectUserProfile) as MemberProfile;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const receipts = useSelector(selectReceipts);
  const isLoading = useSelector(selectFetchReceiptsIsLoading);

  useEffect(() => {
    dispatch(fetchReceipts({role: user.role}));
  }, []);

  return (
    <div className="p-8">
      {isLoading ? (
        <ReceiptsListSkeletonLoader />
      ) : (
        <>
          {receipts.length ? (
            <ReceiptsList receipts={receipts || []} />
          ) : (
            <div className="text-gray-600">
              {t(
                'receipts.emptyReceiptsMessage',
                `You don't have any receipts`,
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default withProviderOnboarding(DPReceipts);
